import MainLayout from '../layouts/main';
import ContactUs from './contact-us';

function ContactUsPage() {
  return (
    <MainLayout loginRequired={false} consultPackageRequired={false} packageRequired={false}>
      <ContactUs/>
    </MainLayout>
  );
}

export default ContactUsPage;
